import useMultiDispatch from 'Core/Hooks/useMultiDispatch'
import { TabGroup, Typography } from 'procyon-ui'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import InstallAgent from 'Views/SettingsPage/Components/Agent'
import { ApproverPolicy } from './components/Tabs/ApproverPolicy'
import { FrontendCA } from './components/Tabs/FrontendCA'
import { Profile } from './components/Tabs/Profile'
import { ReadPolicy } from './components/Tabs/ReadPolicy'
import { ReleaseNotes } from './components/Tabs/ReleaseNotes'
import { TagPolicy } from './components/Tabs/TagPolicy'

function Settings() {
  const { selectDispatch } = useMultiDispatch(['tenantprofiles'])
  //@ts-ignore
  const { tab } = useParams()
  const [activeTab, setActiveTab] = useState(tab)

  const tabs = [
    {
      label: 'Profile',
      tabContent: <Profile />
    },
    {
      label: 'Trusted CA',
      tabContent: <FrontendCA />
    },
    // {
    //   label: 'Tag Policy',
    //   tabContent: <TagPolicy />
    // },
    // {
    //   label: 'Approver Policy',
    //   tabContent: <ApproverPolicy />
    // },
    // {
    //   label: 'Read Policy',
    //   tabContent: <ReadPolicy />
    // },
    {
      label: 'App Downloads',
      tabContent: <InstallAgent />
    },
    {
      label: 'Release Note',
      tabContent: <ReleaseNotes />
    }
  ]

  const TAB_INDEX_MAP = (() => {
    return tabs.reduce((prev, curr, index) => {
      prev[curr.label.toLowerCase()] = index
      return prev
    }, {})
  })()

  const TAB_NAME_MAP = (() => {
    return tabs.reduce((prev, curr, index) => {
      prev[index] = curr.label.toLowerCase()
      return prev
    }, {})
  })()

  useEffect(() => {
    if (tab) {
      setActiveTab(tab)
    }
  }, [tab])

  useEffect(() => {
    selectDispatch(['tenantprofiles', 'orgs', 'tagPolicys', 'userList', 'groupList', 'approvers'])
  }, [])

  return (
    <div className=''>
      <div className='bg-[var(--color-common-bg-secondary)] p-4 flex justify-between items-center'>
        <Typography style={{ color: 'var(--color-font-base)' }} variant='h2'>
          Settings
        </Typography>
      </div>
      <div className='bg-[var(--color-common-bg-base)] p-5'>
        <TabGroup
          controllable={tab === 'releasenote'}
          activeIndex={tab === 'releasenote' ? TAB_INDEX_MAP[activeTab] : 0}
          tabContentHeight='100vh'
          onChangeTab={(_, v) => {
            setActiveTab(TAB_NAME_MAP[v])
          }}
          tabs={tabs}
        />
      </div>
    </div>
  )
}

export { Settings }
